import Account from "@/helper/AccountHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';

/**
 * @method requestOtp
 * @method confirmOtp
 * @method validateOtp
 */
export default {

    /**
     * @param {String} contactNumber (required)
     * @param {String} channel (required) Channel for otp (setup by backend developer)
     * @param {String|Null} uuid (optional)
     */
    requestOtp: function(contactNumber, channel, uuid) {
        const params = {
            contact_number: contactNumber,
            app_id: ConfigManager.getAppId(),
            uuid: uuid,
            channel: channel, //"authen" flow update tel use "contact_number"
        };

        const url = ConfigManager.getApiUrl() + "/auth/otp";
        return BzbsApi.connectBzbsGet(url, null, params).pipe(map(res => res.data));
    },

    /**
     * @param {String} contactNumber
     * @param {String} refcode
     * @param {String|Number} otp
     */
    confirmOtp: function (contactNumber, refcode, otp) {
        const token = Account.getToken();
        const params = {
            contact_number: contactNumber,
            otp: otp,
            refcode: refcode,
        };

        const url = ConfigManager.getApiUrl() + "/auth/bzbs_authen";
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map(res => res.data));
    },

    /**
     * @param {string} contactNumber
     * @param {string} refcode
     * @param {number|string} otp
     * @param {string} channel
     * @returns {Observe}
     */
    validateOtp: function (contactNumber, refcode, otp, channel) {
        const token = Account.getToken();
        const params = {
            contact_number: contactNumber,
            otp: otp,
            refcode: refcode,
            channel: channel,
            app_id: ConfigManager.getAppId(),
            use: false,
        };
        // console.log('params otp validate', params);

        const url = ConfigManager.getApiUrl() + "/auth/validate_otp";
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map(res => res.data));
    },

    /**
     * @param {string} contactNumber
     * @param {string} refcode
     * @param {number|string} otp
     * @param {string} channel
     * @returns {Observe}
     */
     validateOtpAndUse: function (contactNumber, refcode, otp, channel) {
        const token = Account.getToken();
        const params = {
            contact_number: contactNumber,
            otp: otp,
            refcode: refcode,
            channel: channel,
            app_id: ConfigManager.getAppId(),
            use: true,
        };
        // console.log('params otp validate', params);

        const url = ConfigManager.getApiUrl() + "/auth/validate_otp";
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map(res => res.data));
    },
}
